import { v1 as uuid } from 'uuid';
import { useEffect, useState } from 'react';
import { setLocalStorage } from 'utils/localStorage';

const realm = process.env.KEYCLOAK_REALM;

interface Props {
  redirectRoute?: string;
}

/**
  Commence Microsoft oAuth flow inside current window.
  Can be used as a landing page for external sign up urls.
 */
const MicrosoftRedirectAuthentication = ({ redirectRoute }: Props): null => {
  const [uid] = useState(uuid());

  const url = `https://auth.beecastle.com/auth/realms/${realm}/protocol/openid-connect/auth?response_type=code&client_id=bc-fe&redirect_uri=https://${window.location.host}${redirectRoute}&state=${uid}&kc_idp_hint=microsoft&prompt=login`;

  useEffect(() => {
    setLocalStorage('bc-fe-state', uid, false);
    window.location.href = url;
  }, [uid, url]);

  return null;
};

MicrosoftRedirectAuthentication.defaultProps = {
  onAuthFail: null,
  onFlowEnd: null,
  onFlowStart: null,
  redirectRoute: '/oauth/microsoft/complete',
};

export default MicrosoftRedirectAuthentication;
